import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tm-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'], 
})
export class CarouselComponent implements OnInit {
  constructor() { }
  ngOnInit() { }
}
